// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PGm0","largestCol":"styles_largestCol__1waPj","smallestCol":"styles_smallestCol__1VxcY"};